import { CreateSurveyRequest, CreateUserRequest } from './../../../../models/global.request';
//Angular
import { Component, OnInit, SimpleChange, ViewChild, ViewEncapsulation } from "@angular/core";
import { Router  } from '@angular/router';
import {ChangeDetectorRef } from '@angular/core';


import { FormArray, FormGroup, FormBuilder, Validators, AbstractControl, ValidationErrors, ValidatorFn, FormControl } from "@angular/forms";

//Table
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';

//dependecies
import { ToastrService } from "ngx-toastr";
import { ImageCroppedEvent } from 'ngx-image-cropper';

//Models
import { Step } from "src/app/models/Step";
import { Question } from "src/app/models/Question";

//Store
import { Store } from "@ngrx/store";
import { Observable } from "rxjs";

//Actions
import { setStep } from "../../../../stores/sidebar/sidebar.actions";

import { createSurvey } from "../../../../stores/survey/survey.actions";

//States
import { SidebarState } from "../../../../stores/sidebar/sidebar.reducer";
import { Answer, AnswerRange } from "src/app/models/Answer";
import { CodeModel } from "@ngstack/code-editor";
import { User } from "src/app/models/User";

//Utils
import  Utils  from '../../../../utils/utils'

//Constants
import { ROUTES } from '../../../../utils/constants'
import { UserService } from "src/app/services/user/user.service";
import { createUser } from 'src/app/stores/users/users.actions';
import { saveSurveyParams } from 'src/app/stores/survey/survey.actions';


import { CreateUserResponse } from 'src/app/models/global.response';

interface selectDropdownItemMt{
  value: string;
  viewValue: string;
}


@Component({
  selector: "app-create-survey",
  templateUrl: "./create-survey.component.html",
  styleUrls: ["./create-survey.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class CreateSurveyComponent {

  //Common - Variables
  sidebarState$: Observable<SidebarState>;
  currentStepList!: Step[];
  utils: Utils = new Utils();
  //StepZero - Variables

  clientJSON : string = "";
  isValidJSON: boolean = false;
  surveyNameJSON : string = "";
  questionsJSON: any[] = [];
  languagesJSON: string[] = [];
  defaultLanguageJSON: string = "";
  contextsJSON: any[] = [];
  defaultContextJSON: string = "";
  theme = 'vs-dark';

  model: CodeModel = {
    language: 'json',
    uri: 'main.json',
    value: '{}',
  };

  options = {
    lineNumbers: true,
    contextmenu: true,
    minimap: {
      enabled: true,
    },
  };

  existingUsers: any[] = [];
  existingUsersAll: any[] = [];
  emailAlreadyExists: boolean[] = [];
  passwordRegex: RegExp = /^(?=[^A-Z]*[A-Z])(?=[^a-z]*[a-z])(?=\D*\d).{8,}$/;

  //StepOne - Variables
  isVisibleAddNewUser: (boolean | undefined)[] = [false];
  showPassword: boolean = false;
  customers: any = ["Cliente1", "Cliente2", "Cliente3", "Cliente4"];

  //Step Two - Variables
  isVisibleCropImage: boolean | undefined;
  isAllSelected: boolean | undefined;
  imageChangedEvent: any = '';
  croppedImage: any = '';

  //Step Three - Variables


  //Step Four - Variables
  isValidStepFour: boolean = false;

  displayedSourceColumns = ['id', 'description'];
  displayedSelectedColumns = ['id','touchPoint','questionType','description'];
  displayedSelectedSatisfactionColumns = ['id','touchPoint','description'];
  displayedSelectedNPSColumns= ['id','touchPoint','description'];
  displayedSelectedEndPointColumns= ['id','touchPoint','description'];
  displayedSelectedEmotionalQuestionColumns= ['id','touchPoint','description'];

  dataSourceQuestions!: MatTableDataSource<Question>;
  dataSelectedQuestions!: MatTableDataSource<Question>;
  dataSelectedSatisfaction!: MatTableDataSource<Question>;
  dataSelectedNPS!: MatTableDataSource<Question>;
  dataSelectedEndPoint!: MatTableDataSource<Question>;
  dataSelectedEmotionalQuestion!: MatTableDataSource<Question>;

  private paginatorSource!: MatPaginator;
  private sortSource!: MatSort;

  @ViewChild(MatSort, {
    static: false
  }) set matSortSource(ms: MatSort) {
    this.sortSource = ms;
    if(ms)
    this.setPaginationAndSortSourceQuestions();
  }
  @ViewChild(MatPaginator, {
    static: false
  }) set matPaginatorSource(
    mp: MatPaginator
  ) {
    this.paginatorSource = mp;
    if(mp)
    this.setPaginationAndSortSourceQuestions();
  }

  private paginatorSelected!: MatPaginator;
  private sortSelected!: MatSort;

  @ViewChild(MatSort, {
    static: false
  }) set matSortSelected(ms: MatSort) {
    this.sortSelected = ms;
    if(ms)
    this.setPaginationAndSortSelectedQuestions();
  }

  @ViewChild(MatPaginator, {
    static: false
  }) set matPaginatorSelected(
    mp: MatPaginator
  ) {
    this.paginatorSelected = mp;
    if(mp)
    this.setPaginationAndSortSelectedQuestions();
  }

  private paginatorSatisfaction!: MatPaginator;
  private sortSatisfaction!: MatSort;

  @ViewChild(MatSort, {
    static: false
  }) set matSortSatisfaction(ms: MatSort) {
    this.sortSatisfaction = ms;
    if(ms)
    this.setPaginationAndSortSelectedSatisfaction();
  }

  @ViewChild(MatPaginator, {
    static: false
  }) set matPaginatorSatisfaction(
    mp: MatPaginator
  ) {
    this.paginatorSatisfaction = mp;
    if(mp)
    this.setPaginationAndSortSelectedSatisfaction();
  }

  private paginatorNPS!: MatPaginator;
  private sortNPS!: MatSort;

  @ViewChild(MatSort, {
    static: false
  }) set matSortNPS(ms: MatSort) {
    this.sortNPS = ms;
    if(ms)
    this.setPaginationAndSortSelectedNPS();
  }

  @ViewChild(MatPaginator, {
    static: false
  }) set matPaginatorNPS(
    mp: MatPaginator
  ) {
    this.paginatorNPS = mp;
    if(mp)
    this.setPaginationAndSortSelectedNPS();
  }


  private paginatorEndPoint!: MatPaginator;
  private sortEndPoint!: MatSort;

  @ViewChild(MatSort, {
    static: false
  }) set matSortEndPoint(ms: MatSort) {
    this.sortEndPoint = ms;
    if(ms)
    this.setPaginationAndSortSelectedEndPoint();
  }

  @ViewChild(MatPaginator, {
    static: false
  }) set matPaginatorEndPoint(
    mp: MatPaginator
  ) {
    this.paginatorEndPoint = mp;
    if(mp)
    this.setPaginationAndSortSelectedEndPoint();
  }


  private paginatorEmotionalQuestion!: MatPaginator;
  private sortEmotionalQuestion!: MatSort;

  @ViewChild(MatSort, {
    static: false
  }) set matSortEmotionalQuestion(ms: MatSort) {
    this.sortEmotionalQuestion = ms;
    if(ms)
    this.setPaginationAndSortSelectedEmotionalQuestion();
  }

  @ViewChild(MatPaginator, {
    static: false
  }) set matPaginatorEmotionalQuestion(
    mp: MatPaginator
  ) {
    this.paginatorEmotionalQuestion = mp;
    if(mp)
    this.setPaginationAndSortSelectedEmotionalQuestion();
  }

  //Step four - variables

  isViewableAnswerContainer: boolean[] = [];

  touchPointList: selectDropdownItemMt[] = [
    {value: 'contact', viewValue: 'Contatto'},
    {value: 'path', viewValue: 'Percorso'},
    {value: 'suggestion', viewValue: 'Suggestion'},
    {value: 'other', viewValue: 'Other'},
  ];

  questionTypeList: selectDropdownItemMt[] = [
    {value: 'open', viewValue: 'Aperta'},
    {value: 'close', viewValue: 'Chiusa'},
    {value: 'multiple', viewValue: 'Multipla'},
    {value: 'slider', viewValue: 'Slider'},
    {value: 'knob', viewValue: 'Knob'},
    {value: 'elenco', viewValue: 'Elenco'},
  ];

  //Constructor
  constructor(
    private store: Store<{ sidebarState: SidebarState }>,
    public fb: FormBuilder,
    private toastr: ToastrService,
    private userService: UserService,
    private router: Router,
    private cdref: ChangeDetectorRef,
  ) {
    this.sidebarState$ = store.select("sidebarState");
  }

  // On Component Initialized
  ngOnInit(): void {
    this.isVisibleCropImage = false;
    this.sidebarState$.subscribe((sidebarS) => {
      this.currentStepList = sidebarS.stepList;
    });

    this.userService.getUsers().subscribe(data => {
      this.existingUsersAll = data;
      this.existingUsersAll.sort((user1: any, user2: any) => {
        const aValue = user1.name ? user1.name + ' ' + user1.surname : user1.email;
        const bValue = user2.name ? user2.name + ' ' + user2.surname : user2.email;

        return aValue.localeCompare(bValue);
      });
      this.existingUsers = data.filter((user: any) => user.role_name !== 'admin');
    });

    this.stepFourForm.valueChanges.subscribe(form => {
      if(form) {
          const questionsOverviewLenght= this.stepFourForm.controls.questionOverviewListForm?.value?.length || 0;
          const questionsJSONLenght = this.questionsJSON.length

          this.isValidStepFour = this.stepFourForm.valid && (questionsOverviewLenght == questionsJSONLenght);
      }
    });
    // this.onChanges();
    this.changeStep(0);
  }

  initDataTables() {

    this.dataSourceQuestions = new MatTableDataSource(this.questionsJSON);
    this.dataSelectedQuestions = new MatTableDataSource(this.questionsJSON);
    this.dataSelectedSatisfaction = new MatTableDataSource(this.questionsJSON);
    this.dataSelectedNPS = new MatTableDataSource(this.questionsJSON);
    this.dataSelectedEndPoint = new MatTableDataSource(this.questionsJSON);
    this.dataSelectedEmotionalQuestion = new MatTableDataSource(this.questionsJSON);

  }
  // onChanges(): void {
  //   this.filterQuestionsListForm.valueChanges.subscribe(selectedValue  => {
  //     this.dataSourceQuestions = new MatTableDataSource(selectedValue)
  //   })
  //   this.questionOverviewListForm.valueChanges.subscribe(selectedValue  => {
  //     this.dataSelectedQuestions = new MatTableDataSource(selectedValue)
  //   })
  //   this.satisfactionListForm.valueChanges.subscribe(selectedValue  => {
  //     this.dataSelectedSatisfaction = new MatTableDataSource(selectedValue)
  //   })
  // }

  ngAfterViewInit() {
    if(this.paginatorSource)
    this.dataSourceQuestions.paginator = this.paginatorSource;
    if(this.sortSource)
    this.dataSourceQuestions.sort = this.sortSource;

    if(this.paginatorSelected)
    this.dataSelectedQuestions.paginator = this.paginatorSelected;
    if(this.sortSelected)
    this.dataSelectedQuestions.sort = this.sortSelected;

    if(this.paginatorSatisfaction)
    this.dataSelectedSatisfaction.paginator = this.paginatorSatisfaction;
    if(this.sortSatisfaction)
    this.dataSelectedSatisfaction.sort = this.sortSatisfaction;

    if(this.paginatorNPS)
    this.dataSelectedNPS.paginator = this.paginatorNPS;
    if(this.sortNPS)
    this.dataSelectedNPS.sort = this.sortNPS;

    if(this.paginatorEndPoint)
    this.dataSelectedEndPoint.paginator = this.paginatorEndPoint;
    if(this.sortEndPoint)
    this.dataSelectedEndPoint.sort = this.sortEndPoint;

    if(this.paginatorEmotionalQuestion)
    this.dataSelectedEmotionalQuestion.paginator = this.paginatorEmotionalQuestion;
    if(this.sortEmotionalQuestion)
    this.dataSelectedEmotionalQuestion.sort = this.sortEmotionalQuestion;
  }


  setPaginationAndSortSourceQuestions() {
    this.dataSourceQuestions.paginator = this.paginatorSource;
    this.dataSourceQuestions.sort = this.sortSource;
  }

  setPaginationAndSortSelectedQuestions() {
    this.dataSelectedQuestions.paginator = this.paginatorSelected;
    this.dataSelectedQuestions.sort = this.sortSelected;
  }

  setPaginationAndSortSelectedSatisfaction() {
    this.dataSelectedSatisfaction.paginator = this.paginatorSatisfaction;
    this.dataSelectedSatisfaction.sort = this.sortSatisfaction;
  }

  setPaginationAndSortSelectedNPS() {
    this.dataSelectedNPS.paginator = this.paginatorNPS;
    this.dataSelectedNPS.sort = this.sortNPS;
  }

  setPaginationAndSortSelectedEndPoint() {
    this.dataSelectedEndPoint.paginator = this.paginatorEndPoint;
    this.dataSelectedEndPoint.sort = this.sortEndPoint;
  }

  setPaginationAndSortSelectedEmotionalQuestion() {
    this.dataSelectedEmotionalQuestion.paginator = this.paginatorEmotionalQuestion;
    this.dataSelectedEmotionalQuestion.sort = this.sortEmotionalQuestion;
  }

  applyFilterThreeForm(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSourceQuestions.filter = filterValue.trim().toLowerCase();

    if (this.dataSourceQuestions.paginator) {
      this.dataSourceQuestions.paginator.firstPage();
    }
  }

  //Add TouchPoint
  onClickAddTouchPoint () {
    const newTP = this.newTouchPoint?.value ||"";
    const duplicateTp = this.touchPointList.filter((tp: any) => tp.value === newTP);
    if (newTP && duplicateTp.length === 0) {
      this.touchPointList.push({value: newTP, viewValue: newTP});
      this.newTouchPoint?.patchValue('');
      this.toastr.success("New touchpoint added", "Success");
    } else {
      this.toastr.warning("Touchpoint already present", "Warning");
    }
  }

  applyFilterFourForm(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSelectedQuestions.filter = filterValue.trim().toLowerCase();

    if (this.dataSelectedQuestions.paginator) {
      this.dataSelectedQuestions.paginator.firstPage();
    }
  }

  applyFilterFiveForm(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSelectedSatisfaction.filter = filterValue.trim().toLowerCase();

    if (this.dataSelectedSatisfaction.paginator) {
      this.dataSelectedSatisfaction.paginator.firstPage();
    }
  }
  applyFilterSixForm(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSelectedNPS.filter = filterValue.trim().toLowerCase();

    if (this.dataSelectedNPS.paginator) {
      this.dataSelectedNPS.paginator.firstPage();
    }
  }

  applyFilterSevenForm(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSelectedEndPoint.filter = filterValue.trim().toLowerCase();

    if (this.dataSelectedEndPoint.paginator) {
      this.dataSelectedEndPoint.paginator.firstPage();
    }
  }

  applyFilterEightForm(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSelectedEmotionalQuestion.filter = filterValue.trim().toLowerCase();

    if (this.dataSelectedEmotionalQuestion.paginator) {
      this.dataSelectedEmotionalQuestion.paginator.firstPage();
    }
  }

  //Step Forms - Initialized
  stepOneForm = this.fb.group({
    customerName: ["", [Validators.required]],
    users: this.fb.array([
      this.fb.group({
        id: [0],
        userId: ["", [Validators.required]],
        newUser: this.fb.group({
          newMail: ["", [Validators.required, Validators.email, this.validateUserDoesNotExist(0)]],
          newPassword: ["", [Validators.required, Validators.pattern(this.passwordRegex)]],
        })
      })
    ])
  });


  stepTwoForm = this.fb.group({
    surveyName: ["", [Validators.required]],
    surveyNewName: ["", [Validators.required, this.noWhitespaceValidator, Validators.minLength(3), Validators.maxLength(50)]],
    surveyDescription: ["", [Validators.required, this.noWhitespaceValidator, Validators.minLength(3), Validators.maxLength(100)]],
    surveyFileSourceCover:[null, [Validators.required]],
    surveyFileBase64Cover:[''],
    surveyFileNameCover: [''],
  });

  stepThreeForm = this.fb.group({
    filterQuestionsListForm: this.fb.array([], [Validators.required]),
  });

  stepFourForm = this.fb.group({
    questionOverviewListForm: this.fb.array([], [Validators.required]),
    newTouchPoint:[''],
  });




  stepFiveForm = this.fb.group({
    satisfactionListForm: this.fb.array([]),
  });

  stepSixForm = this.fb.group({
    npsListForm: this.fb.array([]),
  });

  stepSevenForm = this.fb.group({
    endPointListForm: this.fb.array([]),
  });

  stepEightForm = this.fb.group({
    emotionalQuestionListForm: this.fb.array([]),
  });
  //Setters e Getters -  stepOneForm
  setCustomerName(value: any) {
    this.customerName?.setValue(value, {
      onlySelf: true,
    });
  }

  setSurveyName(value: any) {
    this.surveyName?.setValue(value, {
      onlySelf: true,
    });
  }

  get customerName() {
    return this.stepOneForm.get("customerName");
  }

  get users() : FormArray {
    return this.stepOneForm.get('users') as FormArray
  }


  //Setters e Getters - stepTwoForm

  setSurveyNewName(element: any) {
    this.surveyNewName?.setValue(element.target.value, {
      onlySelf: true,
    });
  }

  setSurveyFileSourceCover(element: any) {
    this.surveyFileSourceCover?.setValue(element.target.value, {
      onlySelf: true,
    });
  }
  setSurveyFileBase64Cover(element: any) {
    this.surveyFileBase64Cover?.setValue(element.target.value, {
      onlySelf: true,
    });
  }
  setSurveyFileNameCover(element: any) {
    this.surveyFileNameCover?.setValue(element.target.value, {
      onlySelf: true,
    });
  }

  get surveyName() {
    return this.stepTwoForm.get("surveyName");
  }

  get surveyDescription() {
    return this.stepTwoForm.get("surveyDescription");
  }

  get surveyNewName() {
    return this.stepTwoForm.get("surveyNewName");
  }

  get surveyFileSourceCover() {
    return this.stepTwoForm.get("surveyFileSourceCover");
  }
  get surveyFileNameCover() {
    return this.stepTwoForm.get("surveyFileNameCover");
  }

  get surveyFileBase64Cover() {
    return this.stepTwoForm.get("surveyFileBase64Cover");
  }

  //Setters e Getters - stepThreeForm

  setAllSelected ( isChecked: any) {
    this.isAllSelected = isChecked;
    for (let index = 0; index < this.questionsJSON.length; index++) {
      this.removeFilterQuestionList(this.questionsJSON[index]);

    }
    for (let index = 0; index < this.questionsJSON.length; index++) {
      if(isChecked) {
        this.addFilterQuestionList(this.questionsJSON[index]);
      }else if(!isChecked) {
        this.removeFilterQuestionList(this.questionsJSON[index])
      }
    }
  }

  addFilterQuestionList(question: Question) {
    this.filterQuestionsListForm.push(this.newQuestion(question));
  }



  removeFilterQuestionList(idQuestion: Question) {
    const tempQuestion = idQuestion.id;
    const index = this.filterQuestionsListForm.value.findIndex((tQuestion: Question) =>tQuestion.id ===tempQuestion);
    this.filterQuestionsListForm.removeAt(index);
  }

  addOverviewQuestionList(question: Question) {
    this.filterQuestionsListForm.push(this.newQuestion(question));
  }

  removeOverviewQuestionList(idQuestion: Question) {
    const tempQuestion = idQuestion.id;
    const index = this.questionOverviewListForm.value.findIndex((tQuestion: Question) =>tQuestion.id ===tempQuestion);
    this.questionOverviewListForm.removeAt(index);
  }

  addSatisfactionList(question: Question) {

    this.satisfactionListForm.push(this.newQuestion(question));
  }

  removeSatisfactionList(idQuestion: Question) {
    const tempQuestion = idQuestion.id;
    const index = this.satisfactionListForm.value.findIndex((tQuestion: Question) =>tQuestion.id ===tempQuestion);
    this.satisfactionListForm.removeAt(index);
  }

  addNPSList(question: Question) {

    this.npsListForm.push(this.newQuestion(question));
  }

  removeNPSList(idQuestion: Question) {
    const tempQuestion = idQuestion.id;
    const index = this.npsListForm.value.findIndex((tQuestion: Question) =>tQuestion.id ===tempQuestion);
    this.npsListForm.removeAt(index);
  }

  addEndPointList(question: Question) {

    this.endPointListForm.push(this.newQuestion(question));
  }

  removeEndPointList(idQuestion: Question) {
    const tempQuestion = idQuestion.id;
    const index = this.endPointListForm.value.findIndex((tQuestion: Question) =>tQuestion.id ===tempQuestion);
    this.endPointListForm.removeAt(index);
  }

  addEmotionalQuestionList(question: Question) {
    this.emotionalQuestionListForm.push(this.newQuestion(question));
  }

  removeEmotionalQuestionList(idQuestion: Question) {
    const tempQuestion = idQuestion.id;
    const index = this.emotionalQuestionListForm.value.findIndex((tQuestion: Question) =>tQuestion.id ===tempQuestion);
    this.emotionalQuestionListForm.removeAt(index);
  }

  newQuestion(question: Question): FormGroup {
    return this.fb.group({
      id: question.id,
      domanda_id: question.domanda_id,
      description: question.description,
      touchPoint: question.touchPoint,
      type: question.type,
      answers: this.fb.array(question.answers),
      translations: question.translations ? this.fb.array(question.translations) : null,
    })
  }

  get filterQuestionsListForm() : FormArray {
    return this.stepThreeForm.get("filterQuestionsListForm") as FormArray
  }

  get questionOverviewListForm() : FormArray {
    return this.stepFourForm.get("questionOverviewListForm") as FormArray
  }

  get newTouchPoint() {
    return this.stepFourForm.get("newTouchPoint");
  }

  get satisfactionListForm() : FormArray {
    return this.stepFiveForm.get("satisfactionListForm") as FormArray
  }

  get npsListForm() : FormArray {
    return this.stepSixForm.get("npsListForm") as FormArray
  }

  get endPointListForm() : FormArray {
    return this.stepSevenForm.get("endPointListForm") as FormArray
  }

  get emotionalQuestionListForm() : FormArray {
    return this.stepEightForm.get("emotionalQuestionListForm") as FormArray
  }
  //Methods  stepZero

  onCodeChanged(jsonData: any) {
    const isValidFormat = this.testJSON(jsonData);
    let isValidClient = false;
    let isValidSurveyName = false;
    let areValidQuestions = false;
    if(isValidFormat) {
      this.clientJSON = this.getClientFromJSON(jsonData);
      isValidClient = this.clientJSON ? true : false;
      this.surveyNameJSON = this.getSurveyNameFromJSON(jsonData);
      isValidSurveyName = this.surveyNameJSON ? true : false;
      this.questionsJSON = this.getQuestionsFromJSON(jsonData);
      areValidQuestions= this.questionsJSON.length > 0 ? true : false;
      this.languagesJSON = this.getLanguagesFromJSON(jsonData);
      this.defaultLanguageJSON = this.getDefaultLanguageFromJSON(jsonData);
      this.contextsJSON = this.getContextsFromJSON(jsonData);
      this.defaultContextJSON = this.getDefaultContextFromJSON(jsonData);
    }
    this.isValidJSON = isValidFormat && isValidClient && isValidSurveyName;
    if(this.isValidJSON) {
      this.initDataTables();
    }
  }

  testJSON(jsonData : any): boolean {
    if (typeof jsonData !== "string") {
        return false;
    }
    try {
        JSON.parse(jsonData);

        return true;
    } catch (error) {
        return false;
    }
  }

  getClientFromJSON(jsonData : any): string {
    const json = JSON.parse(jsonData);
    this.setCustomerName(json['cliente']);

    return json['cliente'];
  }

  getSurveyNameFromJSON(jsonData : any): string {
    const json = JSON.parse(jsonData);
    this.setSurveyName(json['_id']);

    return json['_id'];
  }


  getQuestionsFromJSON(jsonData : any) {
    const questions: any[] =  [];
    const json = JSON.parse(jsonData);
    const keyPoints = json['keyPoints'];

    for (let index = 0; index < keyPoints.length; index++) {
        const tIndex = index;
        const tFrame = keyPoints[index].frame|| "";
        const tDescription = keyPoints[index].titolo|| "";
        const tTranslations: {language: string, description: string}[] = [];
        if (keyPoints[index].i18n) {
          Object.entries(keyPoints[index].i18n).forEach((value: any) => {
            tTranslations.push({language: value[0], description: value[1].titolo});
          });
        }
        const tType= this.getTypeQuestionFromJSON(keyPoints[index].domanda)|| "";
        const tAnswers= this.getAnswersQuestionFromJSON(keyPoints[index].domanda, tType);
        const tQuestion = new Question (
          tIndex,
          parseInt(keyPoints[index].domanda.id),
          tDescription,
          "",
          tType,
          (tAnswers.map((object: any) => ({ ...object }))),
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          tTranslations);
        questions.push(tQuestion);
    }

    return questions;
  }

  getLanguagesFromJSON(jsonData: any) {
    const json = JSON.parse(jsonData);

    return json['languages'] ?? [];
  }
  getDefaultLanguageFromJSON(jsonData: any) {
    const json = JSON.parse(jsonData);

    return json['defaultLanguage'] ?? "";
  }

  getContextsFromJSON(jsonData: any) {
    const json = JSON.parse(jsonData);

    return json['contexts'] ?? [];
  }
  getDefaultContextFromJSON(jsonData: any) {
    const json = JSON.parse(jsonData);

    return json['defaultContext'] ?? "";
  }

  getTypeQuestionFromJSON (question: any) {
    let type ="";
    if(question.multipla === false) {
      type="close";
    }
    if (question.multipla === true) {
      type="multiple";
    }
    if (question.tipo === "textarea") {
      type="open";
    }
    if (question.tipo === "bea-slider") {
      type="slider";
    }
    if (question.tipo === "knob") {
      type="knob";
    }
    if (question.tipo === "elenco") {
      type="elenco";
    }
    if (question.tipo === "audiobox") {
      type="open";
    }

    return type;
  }

  getAnswersQuestionFromJSON(questionRaw: any, type: string) {
      const answersRaw = questionRaw.risposteValide;
      const answers : any [] = [];

      for (let index = 0; index < answersRaw.length; index++) {
        const tIndex = index;
        const tDescription = type === 'elenco' ? answersRaw[index].valore : answersRaw[index].testo || "";
        const tTranslations: {language: string, description: string}[] | null = [];
        if (answersRaw[index].i18n) {
          Object.entries(answersRaw[index].i18n).forEach((value: any) => {
            tTranslations.push({language: value[0], description: value[1].testo});
          });
        }
        if (type === 'knob' || type === 'slider') {
          const tColor = type === 'knob' ? 'knob-color' : 'slider-color';
          const tMin = answersRaw[index].minimo ? answersRaw[index].minimo : 0;
          const tMax = answersRaw[index].massimo ? answersRaw[index].massimo : 100;
          const tUrlImage = type === 'slider' ? answersRaw[index].immagineDx : questionRaw.immagine;
          const tUrlImage2 = type === 'slider' ? answersRaw[index].immagineSx : "";
          answers.push(new AnswerRange(tIndex,tDescription,tUrlImage, tColor, null, null, tTranslations, tMin, null, null, tMax, tUrlImage2));
        } else {
          const tColor = "grey";
          const tUrlImage = type !== 'elenco' ? answersRaw[index].valore || "" : "";
          answers.push(new Answer(tIndex,tDescription,tUrlImage, tColor, null, null, tTranslations));
        }
      }

      return answers;
  }

  showHidePassword() {
    this.showPassword = !this.showPassword;
  }

  //Methods stepOneForm

  onClickCreateNewUser(index: number) {
    this.stepOneForm.controls.users.at(index).controls.userId.patchValue('');
    this.isVisibleAddNewUser[index] = true;
  }

  onClickSelectUserFromList(index: number) {
    this.stepOneForm.controls.users.at(index).controls.newUser.controls.newMail.patchValue('');
    this.stepOneForm.controls.users.at(index).controls.newUser.controls.newPassword.patchValue('');
    this.isVisibleAddNewUser[index] = false;
  }

  onClickAddUser() {
    this.users.push(this.fb.group({
      id: [this.users.length],
      userId: ["", [Validators.required]],
      newUser: this.fb.group({
        newMail: ["", [Validators.required, Validators.email, this.validateUserDoesNotExist(this.users.length)]],
        newPassword: ["", [Validators.required, Validators.pattern(this.passwordRegex)]],
      })
    }));
  }

  isLastUserValid() {
    const lastIndex = this.users.length - 1;
    if (this.stepOneForm.controls.users.at(lastIndex).controls.userId.valid || (
        this.stepOneForm.controls.users.at(lastIndex).controls.newUser.controls.newMail.valid &&
        this.stepOneForm.controls.users.at(lastIndex).controls.newUser.controls.newPassword.valid)) {
      return true;
    } else {
      return false;
    }
  }

  onClickRemoveUser(user: any) {
    const indexUser = this.users.value.findIndex((tUser: any) => tUser.id === user.id);
    this.users.removeAt(indexUser);

    this.isVisibleAddNewUser.splice(indexUser, 1);
    this.emailAlreadyExists.splice(indexUser, 1);
  }


  //Methods stepTwoForm

  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      const fileSize = file.size / 1024 / 1024;
      const fileType = file.name.split('.').pop();
      const allowedTypes = ['jpg', 'jpeg', 'png', 'gif'];
      if (!allowedTypes.includes(fileType)) {
        this.toastr.error("Formato immagine non accettato", "Wrong File Type");
      } else if (fileSize > 0.08) {
        this.toastr.error("Max File Size", "Immagine con dimensione massima di 800KB");
      } else {
        this.stepTwoForm.patchValue({
          surveyFileNameCover: file
        });
        this.toastr.success("Successfully uploaded!", "Upload image");
      }
    }
  }

  clearSurveyCover() {
    this.toastr.info("Successfully cleared", "Clear image");
    this.croppedImage = "";
    this.imageChangedEvent = "";
    this.stepTwoForm.controls.surveyFileNameCover.reset();
    this.stepTwoForm.controls.surveyFileBase64Cover.reset();
    this.stepTwoForm.controls.surveyFileSourceCover.reset();
  }

  imageCropped(event: ImageCroppedEvent) {
      this.croppedImage = event.base64;
      this.stepTwoForm.patchValue({
        surveyFileBase64Cover: event.base64
      });
  }
  imageLoaded() {
      // show cropper
  }
  cropperReady() {
      // cropper ready
  }
  loadImageFailed() {
      // show message
  }

  //Methods stepThreeForm

  onCheckboxChangeQuestion(event: any, question: Question) {
    if (event.target.checked) {
      this.addFilterQuestionList(question)
    } else {
      this.removeFilterQuestionList(question)
    }
  }
  onCheckboxChangeSatisfaction(event: any, question: Question) {
    for (let index = 0; index < this.satisfactionListForm.length; index++) {
      this.removeSatisfactionList(this.questionsJSON[index]);
    }
    if (event.target.checked) {
      this.addSatisfactionList(question)
    } else {
      this.removeSatisfactionList(question)
    }
  }

  onCheckboxChangeNPS(event: any, question: Question) {
    for (let index = 0; index < this.npsListForm.length; index++) {
      this.removeNPSList(this.questionsJSON[index]);
    }
    if (event.target.checked) {
      this.addNPSList(question)
    } else {
      this.removeNPSList(question)
    }
  }
  onCheckboxChangeEndPoint(event: any, question: Question) {
    for (let index = 0; index < this.endPointListForm.length; index++) {
      this.removeEndPointList(this.questionsJSON[index]);
    }
    if (event.target.checked) {
      this.addEndPointList(question)
    } else {
      this.removeEndPointList(question)
    }
  }
  onCheckboxChangeEmotionalQuestion(event: any, question: Question) {
    for (let index = 0; index < this.emotionalQuestionListForm.length; index++) {
      this.removeEmotionalQuestionList(this.questionsJSON[index]);
    }
    if (event.target.checked) {
      this.addEmotionalQuestionList(question)
    } else {
      this.removeEmotionalQuestionList(question)
    }
  }



  onCheckboxChangeSelectAllQuestions (event: any) {
    if (event.target.checked) {
      // this.addFilterQuestionList(question)
    } else {
      // this.removeFilterQuestionList(question)
    }
  }

  hasBeenCheckedQuestion(question: any) {
    let checked = false;
    checked = this.filterQuestionsListForm.value.some((element: { id: any; }) => {
      if (element.id === question.id) {
        return true;
      }

      return false;
    });

    return checked
  }


  hasBeenCheckedSatisfaction(question: any) {
    let checked = false;
    checked = this.satisfactionListForm.value.some((element: { id: any; }) => {
      if (element.id === question.id) {
        return true;
      }

      return false;
    });

    return checked
  }

  hasBeenCheckedNPS(question: any) {
    let checked = false;
    checked = this.npsListForm.value.some((element: { id: any; }) => {
      if (element.id === question.id) {
        return true;
      }

      return false;
    });

    return checked
  }

  hasBeenCheckedEndPoint(question: any) {
    let checked = false;
    checked = this.endPointListForm.value.some((element: { id: any; }) => {
      if (element.id === question.id) {
        return true;
      }

      return false;
    });

    return checked
  }

  hasBeenCheckedEmotionalQuestion(question: any) {
    let checked = false;
    checked = this.emotionalQuestionListForm.value.some((element: { id: any; }) => {
      if (element.id === question.id) {
        return true;
      }

      return false;
    });

    return checked
  }

  //Methods Step Four
  onSelectChangePropertyValue(event: { value: any; }, propertyName: string, question: Question) {
    const newValue = event.value;
    const tempSelectedQuestion = this.questionOverviewListForm.value.find(((tQuestion : Question)  => tQuestion.id == question.id));
    const tempSelectedIndex = this.questionOverviewListForm.value.findIndex(((tQuestion : Question)  => tQuestion.id == question.id));

    const tempSelectedQuestionAll = this.questionsJSON.find(((tQuestion : Question)  => tQuestion.id == question.id));

    if(tempSelectedQuestion) {
      //Remove old object
      this.questionOverviewListForm.removeAt(tempSelectedIndex);
      //Update temp object value;
      tempSelectedQuestion[propertyName] = newValue;
      if(newValue === "close") {
        for (let index = 0; index < tempSelectedQuestion['answers'].length; index++) {
          tempSelectedQuestion['answers'][index].color = 'grey';
        }
      }
      this.questionOverviewListForm.push(this.newQuestion(tempSelectedQuestion));

      if (tempSelectedQuestionAll && propertyName === 'type') {
        tempSelectedQuestionAll.type = newValue;
        if (newValue === "close") {
          for (let index = 0; index < tempSelectedQuestionAll['answers'].length; index++) {
            tempSelectedQuestionAll['answers'][index].color = 'grey';
          }
        }
      }
    }else{
      //If Not present in selectQuestionList
      const tempSourceQuestion = this.questionsJSON.find(((tQuestion : Question)  => tQuestion.id == question.id));
      if(tempSourceQuestion) {
        tempSourceQuestion[propertyName] = newValue;
        if(newValue === "close") {
          for (let index = 0; index < tempSourceQuestion['answers'].length; index++) {
            tempSourceQuestion['answers'][index].color = 'grey';
          }
        }
        this.questionOverviewListForm.push(this.newQuestion(tempSourceQuestion));
      }
    }
  }

  returnPropertyValueIfExist(propertyName: string, question: Question) {
    const tempSelectedQuestion = this.questionOverviewListForm.value.find(((tQuestion : Question)  => tQuestion.id == question.id));
    if(tempSelectedQuestion) {
      const propertyValue = tempSelectedQuestion[propertyName];

      return propertyValue
    }

    return null
  }

  onSelectChangeAnswerColor(color:string, index:number, question: Question) {
    const tempSelectedQuestion = this.questionOverviewListForm.value.find(((tQuestion : Question)  => tQuestion.id == question.id));
    const tempSelectedIndex = this.questionOverviewListForm.value.findIndex(((tQuestion : Question)  => tQuestion.id == question.id));
    if(tempSelectedQuestion) {
      //Remove old object
      this.questionOverviewListForm.removeAt(tempSelectedIndex);
      //Update temp object value;
      tempSelectedQuestion['answers'][index].color = color;
      this.questionOverviewListForm.push(this.newQuestion(tempSelectedQuestion));
    }else{
      //If Not present in selectQuestionList
      const tempSourceQuestion = this.questionsJSON.find(((tQuestion : Question)  => tQuestion.id == question.id));
      if(tempSourceQuestion) {
        tempSourceQuestion['answers'][index].color = color;
        this.questionOverviewListForm.push(this.newQuestion(tempSourceQuestion));
      }
    }
  }

  onChangeUpdateRangeValue(event: any, index: number, question: Question, property: string) {
    const tempSelectedQuestion = this.questionOverviewListForm.value.find(((tQuestion : Question)  => tQuestion.id == question.id));
    const tempSelectedIndex = this.questionOverviewListForm.value.findIndex(((tQuestion : Question)  => tQuestion.id == question.id));
    if(tempSelectedQuestion) {
      //Remove old object
      this.questionOverviewListForm.removeAt(tempSelectedIndex);
      //Update temp object value;
      tempSelectedQuestion['answers'][index][property] = parseInt(event.target.value);
      this.questionOverviewListForm.push(this.newQuestion(tempSelectedQuestion));
    }else{
      //If Not present in selectQuestionList
      const tempSourceQuestion = this.questionsJSON.find(((tQuestion : Question)  => tQuestion.id == question.id));
      if(tempSourceQuestion) {
        tempSourceQuestion['answers'][index][property] = parseInt(event.target.value);
        this.questionOverviewListForm.push(this.newQuestion(tempSourceQuestion));
      }
    }
  }

  isValidKnobAndSlider() {
    let valid = true;
    const knobSliderQuestions = this.questionOverviewListForm.value.filter((question: Question) => question.type === 'knob' || question.type === 'slider');
    knobSliderQuestions.forEach((question: Question) => {
      question.answers.forEach((answer: AnswerRange) => {
        if (
          !answer.x_start || !answer.y_start ||   // x_start or y_start are not compiled
          answer.x_start < answer.range_start ||  // x_start is less than range start
          answer.x_start > answer.range_end ||    // x_start is greater than range end
          answer.y_start < answer.range_start ||  // y_start is less than range start
          answer.y_start > answer.range_end ||    // y_start is greater than range end
          answer.x_start >= answer.y_start         // x_start is equal to or greater than y_start
        ) {
          valid = false;
        }
      });
    });

    return valid;
  }

  //Common steps methods

  isStepOneValid() {
    const invalidUsers = this.users.controls.filter((user: any) => {
      return !(user.value.userId !== '' || (user.controls.newUser.value.newMail !== '' && user.controls.newUser.controls.newMail.valid && user.controls.newUser.value.newPassword !== '' && user.controls.newUser.controls.newPassword.valid));
    });
    if (invalidUsers.length > 0) {
      return false;
    } else {
      return true;
    }
  }

  onSubmitBackStep(idStep: number): void {
    this.changeStep(idStep - 1);
  }

  onSubmitNextStep(idStep: number): void {
    let isValid = false;
    switch (idStep) {
      case 0:
        if (!this.isValidJSON) {
        } else {
          isValid = true;
        }
        break;
      case 1:
        const invalidUsers = this.users.value.filter((user: any) => {
          return !(user.userId !== '' || (user.newUser.newMail !== '' && user.newUser.newPassword !== ''));
        });
        if (invalidUsers.length > 0) {
        } else {
          isValid = true;
        }
        break;
      case 2:
        if (!this.stepTwoForm.valid) {
        } else {
          isValid = true;
        }
        break;
      case 3:
        if (!this.stepThreeForm.valid) {
        } else {
          isValid = true;
        }
        break;
      case 4:

          if (!this.stepFourForm.valid ) {
          } else {
              isValid = true;

          }
          break;
      case 5:
          if (!this.stepFiveForm.valid) {
          } else {
            isValid = true;
          }
          break;
      case 6:
            if (!this.stepSixForm.valid) {
            } else {
              isValid = true;
            }
            break;
      case 7:
            if (!this.stepSevenForm.valid) {
            } else {
              isValid = true;
            }
            break;
      case 8:
            if (!this.stepEightForm.valid) {
            } else {
              isValid = true;
            }
            break;
      default:
      // code block
    }
    if (isValid) {
      if(idStep == 8) {
        this.saveSurveyParams();
      }else {
        this.changeStep(idStep + 1);
      }
    }
  }


  changeStep(idStep: number): void {
    const tempStepsList = this.currentStepList.map((tStep) => {
      tStep = { ...tStep, isActive: false, isCompleted : (idStep >tStep.id)? true : false};

      return tStep;
    });

    const nextStep = tempStepsList.find((tStep) => tStep.id === idStep);
    let index = 0;
    if (nextStep) {
      index = tempStepsList.map((tStep) => tStep.id).indexOf(nextStep?.id);
    }

    if (nextStep) {
      nextStep.isActive = true;
      tempStepsList[index] = nextStep;
      this.store.dispatch(
        setStep({ currentStep: nextStep, stepList: tempStepsList })
      );
    }
  }

  getUsersFromUsersListForm() {
    const userListForm = this.stepOneForm.value.users;
    let users: any = null;
    if(userListForm) {
      const userIds_full = userListForm.filter((user: any) => user.userId !== '');
      const newUsers_full = userListForm.filter((user: any) => user.newUser.newMail !== '' && user.newUser.newPassword !== '');
      const userIds = userIds_full.map((user: any) => parseInt(user.userId));
      const newUsers = newUsers_full.map((user: any) => (new User(user.newUser.newMail, "", "", user.newUser.newPassword, "")));
      users = {
        userIds: userIds,
        newUsers: newUsers,
      }
    }

    return users;
  }

  saveSurveyParams () {
    const allUsers = this.getUsersFromUsersListForm();
    const questions = this.getQuestionsFromListForm();
    const users = allUsers.newUsers;
    const userIdsRegistered = allUsers.userIds;
    const customerName = this.stepOneForm.value.customerName || "";
    const surveyName = this.stepTwoForm.value.surveyName || "";
    const surveyCustomName = this.stepTwoForm.value.surveyNewName || "";
    const surveyDescription = this.stepTwoForm.value.surveyDescription || "";
    const surveyFileBase64Cover = this.stepTwoForm.value.surveyFileBase64Cover || "";
    const params = {
      customerName,
      surveyName,
      surveyDescription,
      surveyCustomName,
      surveyFileBase64Cover,
      users,
      questions,
      userIdsRegistered,
      languages: this.languagesJSON,
      defaultLanguage: this.defaultLanguageJSON,
      contexts: this.contextsJSON,
      defaultContext: this.defaultContextJSON,
    }
    // console.log("params", params);

    this.store.dispatch(saveSurveyParams({ createSurveyParams: params }));

  }

  getQuestionsFromListForm() {
    const filterQuestionsListFormValue = this.stepThreeForm.value.filterQuestionsListForm as Question[];
    const questionOverviewListFormValue = this.stepFourForm.value.questionOverviewListForm as Question[];
    const satisfactionListFormValue = this.stepFiveForm.value.satisfactionListForm as Question[];
    const npsListFormValue = this.stepSixForm.value.npsListForm as Question[];
    const endPointListFormValue = this.stepSevenForm.value.endPointListForm as Question[];
    const emotionalScoreListFormValue = this.stepEightForm.value.emotionalQuestionListForm as Question[];
    const questions: Question[] =  [];
    if(questionOverviewListFormValue) {
      questionOverviewListFormValue.forEach((tQuestion ) => {
        const isFilterQuestion = this.questionExists(filterQuestionsListFormValue,tQuestion);
        const isQuestionOverview = true;
        const isSatisfaction = this.questionExists(satisfactionListFormValue,tQuestion);
        const isNps = this.questionExists(npsListFormValue,tQuestion);
        const isEndPoint = this.questionExists(endPointListFormValue,tQuestion);
        const isEmotionalQuestion = this.questionExists(emotionalScoreListFormValue,tQuestion);
        questions.push(
          new Question (
            tQuestion.domanda_id,
            tQuestion.domanda_id,
            tQuestion.description,
            tQuestion.touchPoint,
            tQuestion.type,
            tQuestion.answers,
            null,
            isFilterQuestion,
            isQuestionOverview,
            isSatisfaction,
            isNps,
            isEndPoint,
            isEmotionalQuestion,
            null,
            tQuestion.translations
            ))
      });
    }
    questions.sort((aQuesiton, bQuestion) => aQuesiton.id - bQuestion.id);

    return questions;
  }

  questionExists(arrayList: Question[], question: Question) {
    return arrayList.some((el: any) => {
      return el.description === question.description;
    });
  }

  //Toggles

  // toggleNewUser() {
  //   this.isVisibleAddNewUser = true;
  // }
  toggleCropImage() {
    this.isVisibleCropImage = !this.isVisibleCropImage;
  }

  trackByFn(index: any, item: any) {
    return item.id;
  }

  validateUserDoesNotExist(index: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const newEmail = control.value;
      const emailExists = this.existingUsersAll.filter((user: any) => user.email === newEmail);
      this.emailAlreadyExists[index] = emailExists.length > 0 ? true : false;

      return emailExists.length > 0 ? { forbidden: { message: "Esiste già un utente con questa email" } } : null;
    };
  }

  noWhitespaceValidator(control: FormControl) {
    return (control.value || '').trim().length? null : { 'whitespace': true };
  }

}

